import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        overflow: 'visible',
        paddingBottom: Theme.primaryPaddingBottom,
        paddingHorizontal: Theme.primaryMargin
    },
    promo: {
        marginBottom: 26
    },
    carouselsContainer: {
        marginTop: Theme.primaryMargin,
        paddingHorizontal: Theme.primaryMargin
    },
    carousel: {
        marginTop: 20,
        marginEnd: -Theme.primaryMargin,
        marginRight: -Theme.primaryMargin
    },
    tvGuideButton: {
        marginHorizontal: Theme.primaryMargin,
        marginBottom: 26,
        paddingRight: 0
    },
    tvGuideRow: {
        flexDirection: 'row',
        marginTop: 20,
        marginHorizontal: Theme.primaryMargin
    },
    tvGuideRowTitle: {
        flex: 1,
        justifyContent: 'center'
    },
    tvGuideRowTitleText: {
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        fontSize: 24
    },
    promoContainer: {
        flexDirection: 'row',
        height: 180,
        marginTop: 20,
        alignSelf: 'stretch'
    },
    detailsContainer: {
        width: 330,
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        paddingTop: 15,
        marginHorizontal: 16
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        promo: {
            margin: 0
        },
        tvGuideButton: {
            ...baseStyles.tvGuideButton,
            alignSelf: 'flex-end',
            minWidth: 185
        },
        carouselsContainer: {
            ...baseStyles.carouselsContainer,
            paddingRight: Theme.primaryMargin,
            paddingLeft: Theme.primaryMargin
        },
        carousel: {
            ...baseStyles.carousel,
            marginRight: 0,
            marginEnd: 0
        }
    };
}

export default StyleSheet.create(baseStyles);
